export default "__VITE_ASSET__9751b5df__"